var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      {
        staticClass: "header",
        staticStyle: {
          position: "absolute",
          left: "20%",
          "z-index": "999",
          color: "yellow",
        },
      },
      [
        _c("h1", { staticClass: "fs20 marginTop5" }, [
          _vm._v(_vm._s(_vm.storeName)),
        ]),
        _c("h1", { staticClass: "fs10 marginBottom5" }, [
          _vm._v(_vm._s(_vm.deviceName)),
        ]),
      ]
    ),
    _c("div", { staticClass: "content" }, [
      _c(
        "div",
        { staticClass: "video-container" },
        [
          _c("i-mou-video", {
            ref: "imouvideo",
            attrs: {
              width: 600,
              height: 400,
              "device-id": _vm.deviceId,
              "channel-id": _vm.channelId,
              pwd: _vm.pwd,
            },
          }),
          _c("div", { staticClass: "video-control" }, [
            _c(
              "div",
              { staticClass: "button-row" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.handleNumberKey({ key: "7" })
                      },
                    },
                  },
                  [_vm._v("左上")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.handleNumberKey({ key: "8" })
                      },
                    },
                  },
                  [_vm._v("上")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.handleNumberKey({ key: "9" })
                      },
                    },
                  },
                  [_vm._v("右上")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "button-row" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.handleNumberKey({ key: "4" })
                      },
                    },
                  },
                  [_vm._v("左")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.handleNumberKey({ key: 107 })
                      },
                    },
                  },
                  [_vm._v("全屏")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.handleNumberKey({ key: "6" })
                      },
                    },
                  },
                  [_vm._v("右")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "button-row" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.handleNumberKey({ key: "1" })
                      },
                    },
                  },
                  [_vm._v("左下")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.handleNumberKey({ key: "2" })
                      },
                    },
                  },
                  [_vm._v("下")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.handleNumberKey({ key: "3" })
                      },
                    },
                  },
                  [_vm._v("右下")]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }